import type { CSSProperties, FC } from 'react';
import { useDragLayer, type XYCoord } from 'react-dnd';

import DraggableTypes from '../../../constants/draggable_types';

import styles from './column_drag_layer.module.css';

function getItemStyles(currentOffset: XYCoord | null): CSSProperties {
  if (!currentOffset) {
    return {};
  }
  const { x, y } = currentOffset;
  return {
    transform: `translate(${x + 14}px, ${y + 14}px)`,
  };
}

const ColumnDragLayer: FC = () => {
  const { isDragging, itemType, item, currentOffset } = useDragLayer(
    (monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      currentOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
    }),
  );

  if (
    !isDragging ||
    itemType !== DraggableTypes.TABLE_COLUMN ||
    !currentOffset
  ) {
    return null;
  }
  const { title } = item;

  return (
    <div className={styles.root}>
      <div className={styles.item} style={getItemStyles(currentOffset)}>
        {title}
      </div>
    </div>
  );
};

export default ColumnDragLayer;
